import { Condition } from '@/shared/api/protocol-ts/model/dto_report_condition_pb';

export const filterConditionsByReportID = (
  conditions: Condition[],
  reportID: string,
) => conditions.filter((condition) => condition.ReportID === reportID);
